import { render } from "./AppStatistiche.vue?vue&type=template&id=75ea49da&scoped=true"
import script from "./AppStatistiche.vue?vue&type=script&lang=js"
export * from "./AppStatistiche.vue?vue&type=script&lang=js"

import "./AppStatistiche.vue?vue&type=style&index=0&id=75ea49da&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ea49da"]])

export default __exports__